import config from 'config';
import axiosClient from 'config/axios';
import { ListPayload, ListResponse, SuccessResponse } from 'core/http/response';
import { Ics2EnsTemplateListParams, Ics2EnsTemplateRequest, Ics2EnsTemplateResponse } from './ics2-ens-template';

export const ics2EnsTemplatesUrl = `${config.declarationTemplatesUrl}/ics2-ens`;

export const createIcs2EnsTemplate = (request: Ics2EnsTemplateRequest): Promise<Ics2EnsTemplateResponse> =>
    axiosClient
        .post<SuccessResponse<Ics2EnsTemplateResponse>>(ics2EnsTemplatesUrl, request)
        .then((response) => response.data.payload);

export const getIcs2EnsTemplate = (templateId: string): Promise<Ics2EnsTemplateResponse> =>
    axiosClient
        .get<SuccessResponse<Ics2EnsTemplateResponse>>(`${ics2EnsTemplatesUrl}/${templateId}`)
        .then((response) => response.data.payload);

export const listIcs2EnsTemplates = (
    params?: Ics2EnsTemplateListParams
): Promise<ListPayload<Ics2EnsTemplateResponse>> =>
    axiosClient
        .get<ListResponse<Ics2EnsTemplateResponse>>(ics2EnsTemplatesUrl, { params })
        .then((response) => response.data.payload);

export const updateIcs2EnsTemplate = (
    templateId: string,
    request: Ics2EnsTemplateRequest
): Promise<Ics2EnsTemplateResponse> =>
    axiosClient
        .put<SuccessResponse<Ics2EnsTemplateResponse>>(`${ics2EnsTemplatesUrl}/${templateId}`, request)
        .then((response) => response.data.payload);

export const deleteIcs2EnsTemplate = (templateId: string): Promise<void> =>
    axiosClient.delete(`${ics2EnsTemplatesUrl}/${templateId}`).then(() => undefined);
